import { type StateTree } from "pinia";
import { ProfileUserInformationModel } from "~~/package/mapper/profile/model/ProfileUserInformationModel";
import { ProfileUserAssessmentModel } from "~~/package/mapper/profile/model/ProfileUserAssessmentModel";
import { ProfileUserContestModel } from "~~/package/mapper/profile/model/ProfileUserContestModel";
import type {
    ProfileUserInformationWorkExperienceModel
} from "~~/package/mapper/profile/model/ProfileUserInformationWorkExperienceModel";
import type {
    ProfileUserInformationEducationModel
} from "~~/package/mapper/profile/model/ProfileUserInformationEducationModel";


export interface ProfileStoreState extends StateTree {
    userInfo: ProfileUserInformationModel,
    assessmentList: ProfileUserAssessmentModel[],
    contestList: ProfileUserContestModel[],
    workExperienceList: ProfileUserInformationWorkExperienceModel[],
    educationList: ProfileUserInformationEducationModel[],
}

export const state = (): ProfileStoreState => ({
    userInfo: new ProfileUserInformationModel(),
    assessmentList: [],
    contestList: [],
    workExperienceList: [],
    educationList: []
});
